import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions/permissionEngine';
import type { Supplier, SupplierCreatePayload, SupplierUpdatePayload } from '../types/suppliers.types';

export const suppliersService = {
  async fetchSuppliers() {
    const { data, error } = await supabase
      .from('suppliers')
      .select('*')
      .order('name', { ascending: true });

    if (error) throw error;
    return (data || []) as Supplier[];
  },

  async createSupplier(userId: string, companyId: string, payload: SupplierCreatePayload) {
    await permissionEngine.assert(userId, 'inventory.suppliers.create', { companyId });

    const { data, error } = await supabase
      .from('suppliers')
      .insert({
        ...payload,
        status: payload.status || 'active',
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async updateSupplier(userId: string, companyId: string, id: string, payload: SupplierUpdatePayload) {
    await permissionEngine.assert(userId, 'inventory.suppliers.update', { companyId });

    const { error } = await supabase
      .from('suppliers')
      .update({
        ...payload,
      })
      .eq('id', id);

    if (error) throw error;
    return true;
  },

  async deleteSupplier(userId: string, companyId: string, id: string) {
    await permissionEngine.assert(userId, 'inventory.suppliers.delete', { companyId });

    const { error } = await supabase
      .from('suppliers')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
};
